export const ListStyles = () => {
  return {
    styleOverrides: {
      root: {
        padding: "0px",
      }
    }
  }
}